import { render, staticRenderFns } from "./proportion.vue?vue&type=template&id=0b3e5179&scoped=true"
import script from "./proportion.vue?vue&type=script&lang=js"
export * from "./proportion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e5179",
  null
  
)

export default component.exports